export const menuSelectEntryTracking = (navItem, department) => {
    window.dataLayer = window.dataLayer || [];

    const navLevel = department.id === navItem.navigationId ? 1 : navItem.lvl;
    const navName = department.id === navItem.navigationId ? department.name : navItem.languageContext.en?.name;

    const trackingData = {
        event: 'nav_menu_select_entry',
        navigation_level: navLevel,
        item_category: department.name,
        entry_name: navName
    };

    window.dataLayer.push(trackingData);
};

export const menuSelectItemListTracking = (navItem, department) => {
    window.dataLayer = window.dataLayer || [];

    const {
        page_type: pageType,
        page_path: pagePath
    } = App.Config.GaTrackingPage;

    const trackingData = {
        event: 'nav_menu_select_item_list',
        item_list_id: navItem.navigationId,
        navigation_level: navItem.lvl,
        item_category: department.name,
        page_type: pageType,
        page_path: pagePath
    };

    if (navItem.type === 'listing') {
        trackingData.item_list_name = navItem.type;
    }

    if (navItem.url && navItem.url.includes('brands-a-z')) {
        trackingData.item_list_name = 'brands-a-z';
    }

    window.dataLayer.push(trackingData);
};

export const burgerMenuToggleTracker = (open) => {
    window.dataLayer = window.dataLayer || [];

    if (open) {
        window.dataLayer.push({
            event: 'nav_menu_open'
        });
    } else {
        window.dataLayer.push({
            event: 'nav_menu_exit'
        });
    }
};
